import { Col, Divider, Row } from 'antd';
import { useEffect, useState } from 'react';
import { MASTER_CATEGORY_LIST } from 'utilities/constants/COMMON';
import { ItemView } from '../../CU-015-02/components/ItemView';
import { StepProps } from '../props/StepProps';

export const StepViewOne = ({ data, masterData }: StepProps) => {
    const [isShowAddress, setIsShowAddress] = useState<boolean>(false);

    useEffect(() => {
        if (data?.designatedAddressDiv == '99') {
            setIsShowAddress(true);
        }
    }, [data]);

    return (
        <>
            <Row className="min-w-min">
                <div className="w-full mb-[48px]">
                    <span className="content-step-form heading-step-form">会社情報</span>
                    <Divider className="mb-6 my-1" />
                    <Row gutter={[0, 12]} className="mb-6">
                        <Col span={12} className="pr-[12px]">
                            <ItemView
                                label="会社名"
                                value={data?.companyName}
                                labelClassName="content-step-form label-step-form"
                            />
                        </Col>
                        <Col span={12} className="pl-[12px]">
                            <ItemView
                                label="会社名（カナ）"
                                value={data?.companyNameKana}
                                labelClassName="content-step-form label-step-form"
                            />
                        </Col>
                    </Row>
                    <Row gutter={[0, 12]} className="mb-6">
                        <Col span={12} className="pr-[12px]">
                            <ItemView
                                label="会社の郵便番号（ハイフンなし）"
                                value={data?.companyPostalCode}
                                type="postcode"
                                formatNumber={false}
                                labelClassName="content-step-form label-step-form"
                            />
                        </Col>
                        <Col span={12} className="pl-[12px]">
                            <ItemView
                                label="会社の所在地"
                                value={data?.companyAddress}
                                labelClassName="content-step-form label-step-form"
                            />
                        </Col>
                    </Row>
                    <Row gutter={[0, 12]} className="mb-6">
                        <Col span={12} className="pr-[12px]">
                            <ItemView
                                label="代表者名"
                                value={data?.representativeName}
                                labelClassName="content-step-form label-step-form"
                            />
                        </Col>
                        <Col span={12} className="pl-[12px]">
                            <ItemView
                                label="代表者名（カナ）"
                                value={data?.representativeNameKana}
                                labelClassName="content-step-form label-step-form"
                            />
                        </Col>
                    </Row>
                    <Row gutter={[0, 12]} className="mb-6">
                        <Col span={12} className="pr-[12px]">
                            <ItemView
                                label="会社の電話番号（ハイフンなし）"
                                value={data?.representativePhoneNumber}
                                type="phone"
                                formatNumber={false}
                                labelClassName="content-step-form label-step-form"
                            />
                        </Col>
                    </Row>
                    <Row gutter={[0, 12]} className="mb-6">
                        <Col span={12} className="pr-[12px]">
                            <ItemView
                                label="担当者氏名"
                                value={data?.picName}
                                labelClassName="content-step-form label-step-form"
                            />
                        </Col>
                        <Col span={12} className="pl-[12px]">
                            <ItemView
                                label="担当者氏名（カナ）"
                                value={data?.picNameKana}
                                type="phone"
                                formatNumber={false}
                                labelClassName="content-step-form label-step-form"
                            />
                        </Col>
                    </Row>
                    <Row gutter={[0, 12]} className="mb-6">
                        <Col span={12}>
                            <ItemView
                                label="担当者の連絡先（ハイフンなし）"
                                value={data?.picPhoneNumber01}
                                type="phone"
                                formatNumber={false}
                                labelClassName="content-step-form label-step-form"
                            />
                        </Col>
                        <Col span={12} className="pl-[12px]">
                            <ItemView
                                label="担当者の連絡先（内線）"
                                value={data?.picPhoneExt01}
                                labelClassName="content-step-form label-step-form"
                            />
                        </Col>
                    </Row>
                    <Row gutter={[0, 12]} className="mb-6">
                        <Col span={12}>
                            <ItemView
                                label="担当者のメールアドレス"
                                value={data?.picEmail01}
                                labelClassName="content-step-form label-step-form"
                            />
                        </Col>
                    </Row>
                </div>
                <div className="w-full">
                    <span className="content-step-form heading-step-form">送付先</span>
                    <Divider className="mb-6 my-1" />
                    <Row gutter={[0, 12]} className="mb-6">
                        <Col span={24} className="pr-[12px]">
                            <ItemView
                                label="送付先区分"
                                value={data?.designatedAddressDiv}
                                options={
                                    masterData
                                        ? masterData[
                                              MASTER_CATEGORY_LIST.ADDRESSEE_DIV_CLASSIFICATION
                                          ]
                                        : []
                                }
                                labelClassName="content-step-form label-step-form"
                            />
                        </Col>
                    </Row>

                    <Row gutter={[0, 12]} className="mb-6">
                        <Col span={12} className="pr-[12px]">
                            <ItemView
                                label="送付先の郵便番号（ハイフンなし）"
                                value={data?.designatedAddressPostalCode}
                                type="postcode"
                                formatNumber={false}
                                labelClassName="content-step-form label-step-form"
                            />
                        </Col>
                        <Col span={12} className="pl-[12px]">
                            <ItemView
                                label="送付先の住所"
                                value={data?.designatedAddress}
                                labelClassName="content-step-form label-step-form"
                            />
                        </Col>
                    </Row>
                    <Row gutter={[0, 12]}>
                        <Col span={12} className="pr-[12px]">
                            <ItemView
                                label="送付先の名称（事業者名等）"
                                value={data?.designatedAddressOfficeName}
                                labelClassName="content-step-form label-step-form"
                            />
                        </Col>
                    </Row>
                </div>
            </Row>
        </>
    );
};
